class LocalStorageProvider {
  static setStorage(storage, secureStorage, secureKeys = []) {
    LocalStorageProvider.storage = storage
    LocalStorageProvider.secureStorage = secureStorage // for mobile
    LocalStorageProvider.secureKeys = secureKeys // for mobile
  }

  static getStorageType(key) {
    if (LocalStorageProvider.secureKeys?.includes(key)) {
      return LocalStorageProvider.secureStorage
    }

    return LocalStorageProvider.storage
  }

  static set(key, value, options) {
    const storageType = LocalStorageProvider.getStorageType(key)

    if (!storageType) return
    if (value !== null && value !== undefined) {
      try {
        storageType.setItem(key, JSON.stringify(value))
      } catch (e) {
        if (options?.onError) {
          options.onError(e)
        }
      }
    } else {
      storageType.removeItem(key)
    }
  }

  static get(key) {
    const storageType = LocalStorageProvider.getStorageType(key)

    if (!storageType) return Promise.resolve(null)
    try {
      // const value = LocalStorageProvider.storage.getItem(key)
      // result = JSON.parse(value)
      return getValue(key, storageType)
    } catch (e) {
      return Promise.resolve(null)
    }
  }

  // leave "sync" escape hatch to ease usage with components
  static getSync(key) {
    const storageType = LocalStorageProvider.getStorageType(key)

    if (!storageType) return null
    try {
      const value = storageType.getItem(key)
      return value ? JSON.parse(value) : null
    } catch (e) {
      return null
    }
  }
}

try {
  LocalStorageProvider.storage =
    typeof window !== 'undefined' && window.localStorage ? localStorage : null
} catch (err) {
  // `window.localStorage` crashes in incognito with
  //  Uncaught DOMException: Failed to read the 'localStorage' property from 'Window': Access is denied for this document.
  console.error(err)
}

async function getValue(key, storageType) {
  const value = await Promise.resolve(storageType.getItem(key))
  return value ? JSON.parse(value) : null
}

export default LocalStorageProvider
